import {FC} from 'react'
import {Redirect, useHistory, useParams} from 'react-router-dom'
import {AttachmentsForm} from 'features/procedures/AttachmentsForm'
import {useQuery} from 'hooks/graphql'
import {
  VERIFY_PROCEDURE_CURRENT_STATUS,
  VerifyProcedureCurrentStatusQueryResult,
  VerifyProcedureCurrentStatusQueryVariables,
} from './query'

// ProcedureAttachmentに対応しているprocedure_type
const SUPPORTED_PROCEDURE_TYPES = [
  'start_childcare',
  'extend_childcare',
  'finish_childcare',
  'parental_leave',
  'additional_childcare_leave_allowance',
  'parental_leave_support_allowance',
]

export const Attachments: FC = () => {
  const {id: procedureStatusId} = useParams<{id: string}>()
  const history = useHistory()

  const {data, loading} = useQuery<VerifyProcedureCurrentStatusQueryResult, VerifyProcedureCurrentStatusQueryVariables>(
    VERIFY_PROCEDURE_CURRENT_STATUS,
    {
      variables: {procedureStatusId},
      fetchPolicy: 'network-only',
    }
  )
  const procedureStatus = data?.client.procedureStatus

  const afterSubmit = async () => {
    history.push(`/procedure_statuses/${procedureStatusId}`)
  }

  if (loading) {
    return null
  }

  // ProcedureAttachment非対応手続きの場合はリダイレクト
  if (procedureStatus?.procedureType && !SUPPORTED_PROCEDURE_TYPES.includes(procedureStatus.procedureType)) {
    return <Redirect to={`/procedure_statuses/${procedureStatusId}`} />
  }

  if (procedureStatus?.status && procedureStatus.status !== 'in_progress') {
    return <Redirect to={`/procedure_statuses/${procedureStatusId}`} />
  }

  return (
    <AttachmentsForm
      procedureStatusId={procedureStatusId}
      submitText="保存"
      afterSubmit={afterSubmit}
      procedureContext="admin"
    />
  )
}
